import { types } from "../action-types";

const initialState = {
  loading: false,
  gigs: [],
  error: false,
};

const getGigsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_GIG_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.GET_GIG_SUCCESS:
      return {
        ...state,
        loading: false,
        gigs: action.payload,
        error: false,
      };
    case types.GET_GIG_FAILURE:
      return {
        ...state,
        loading: false,
        gigs: [],
        error: true,
      };
    default:
      return state;
  }
};

export default getGigsReducer;
